import React from 'react'
import '../styles/components/MenuButton.css'

const MenuButton = ({ children, backgroundColor, Icon, onClick, className }) => {
  return (
    <button className={`menu-button${className ? ` ${className}` : ''}`} style={{ backgroundColor }} onClick={onClick}>
      <Icon color='white' className='menu-button-icon' size={24} />
      {children}
    </button>
  )
}

export default MenuButton



// WEBPACK FOOTER //
// ./src/components/MenuButton.js